/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-11-13",
    versionChannel: "nightly",
    buildDate: "2024-11-13T00:06:11.308Z",
    commitHash: "9e51cc47bdc6216e47c2e80b8b07710eee7c8c0a",
};
